
import React, { useState, useEffect, useContext, createContext, Component } from 'react';
import ReactDOM from 'react-dom';
import serialize from 'form-serialize';
import axios from 'axios';
import { Route, Redirect } from 'react-router-dom';
import { Link, animateScroll as scroll } from "react-scroll";

import {api_path} from '../../server.js'; 


import Header from '../../components/Header';


function Perfil() {

    const [user_id, setUser_id] = useState('');
    const [field_status, setField_status] = useState('');
    const [field_nome, setField_nome] = useState('');
    const [field_cpf, setField_cpf] = useState('');
    const [field_registroprofissional, setField_registroprofissional] = useState('');
    const [field_email, setField_email] = useState('');
    const [field_fone, setField_fone] = useState('');
    const [field_cep, setField_cep] = useState('');
    const [field_endereco, setField_endereco] = useState('');
    const [field_numero, setField_numero] = useState('');
    const [field_complemento, setField_complemento] = useState('');
    const [field_bairro, setField_bairro] = useState('');
    const [field_cidade, setField_cidade] = useState('');
    const [field_uf, setField_uf] = useState('');
    const [field_s1, setField_s1] = useState('');
    const [field_s2, setField_s2] = useState('');

    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            const storageUser = localStorage.getItem("SistemaUser");
            if(storageUser){
                let storageSistemaUser = JSON.parse(storageUser);
                var user = storageSistemaUser.user_id;
                setUser_id(user);
                getCliente(user);
                
            }
        }
        return () =>{
            unmounted=true;
        };
    }, [])




    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            
           // alert(user_id);
        }
        return () =>{
            unmounted=true;
        };
    }, [user_id])




    function getCliente(id){

        const bodyVisualiza = {
            acao: 'visualiza',
            user: id
            /*dados:{user: id}*/
          }
          
        if(id!==""){
            axios.post(api_path()+'sistema/cliente.cad.php', bodyVisualiza, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then((response) => {

                setUser_id(response.data.codigo);
                setField_status(response.data.status);
                setField_nome(response.data.nome);
                setField_cpf(response.data.cpf);
                setField_registroprofissional(response.data.registroprofissional);
                setField_email(response.data.email);
                setField_fone(response.data.fone);
                setField_cep(response.data.cep);
                setField_endereco(response.data.endereco);
                setField_numero(response.data.numero);
                setField_complemento(response.data.complemento);
                setField_bairro(response.data.bairro);
                setField_cidade(response.data.cidade);
                setField_uf(response.data.uf);

              })
              .catch(function (response) {
                    //console.log(response);
              });
              return;
        }else{
            //alert('Ocorreu um problema na conexao com o servidor.');
        }

    }




    function enviaform(e){

        
        const form = e.currentTarget;
        let dados= serialize(form, {hash: true, empty: true})
        const bodyDadosProp = { acao: 'cadastro', dados}
        //field_s1
        if(user_id!=""){
            axios.post(api_path()+'sistema/cliente.cad.php', bodyDadosProp, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then((response) => {

                let dadosCliente = response.data;
                let codigo = dadosCliente.codigo;
                let erro = dadosCliente.erro;
                let erro_msg = dadosCliente.erro_msg;
                if(erro=="NAO"){ }
                alert(erro_msg);

              })
              .catch(function (response) {
                    //handle error
                    //console.log(response);
              });
              return;
        }else{
            alert('Ocorreu um problema na conexao com o servidor.');
        }

    }

    function handleSubmitCliente(e){
        e.preventDefault();
        var varS1 = e.target.s1.value;
        var varS2 = e.target.s2.value;

        if(varS1==""){
            enviaform(e);
        }else{
            if(varS1==varS2){
                enviaform(e);
            }else{
                alert("As senhas digitadas s�o diferentes! Tente novamente.");
                setField_s1('');
                setField_s2('');
            }
        }
    
    }

    

    return (
        <div className="App grid-container">
        <Header/>
          <div className="grid-container">

          <nav role="navigation">
                <ul className="breadcrumbs">
                    <li><a href="../dashboard">Home</a></li>
                    <li>Perfil</li>
                </ul>
            </nav>



            <div className="card container-perfil">
                <div className="card-divider"><h4>Perfil</h4></div>
                <div className="card-section">

                    <form name="cadastroperfil" id="cadastroperfil" onSubmit={handleSubmitCliente}>

                            <input name="user" id="user" type="hidden" value={user_id} onChange={(e) => setUser_id(e.target.value)} required/>
                            <input name="status" id="status" type="hidden" value="ATIVO" required/>
                            <div className="grid-x grid-padding-x">
                                <div className="small-12 medium-12 large-12 cell">
                                    <label htmlFor="nome" className="form-label">Nome / Razao Social
                                    <input name="nome" id="nome" type="text" value={field_nome} onChange={(e) => setField_nome(e.target.value)} className="form-control" placeholder="Nome Completo" required/>
                                    </label>
                                </div>
                                <div className="small-12 medium-8 large-8 cell">
                                    <label htmlFor="cpf_cnpj" className="form-label">Cpf/Cnpj
                                    <input name="cpf" id="cpf" type="text" value={field_cpf} onChange={(e) => setField_cpf(e.target.value)} required/>
                                    </label>
                                </div>
                                <div className="small-12 medium-4 large-4 cell">
                                    <label htmlFor="registroprofissional" className="form-label">Registro Profissional</label>
                                    <input name="registroprofissional" id="registroprofissional" type="text" value={field_registroprofissional} onChange={(e) => setField_registroprofissional(e.target.value)} required/>
                                </div>
                            </div>
                            <div className="grid-x grid-padding-x">
                            <div className="small-12 medium-8 large-8 cell">
                                    <label htmlFor="email" className="form-label">email</label>
                                    <input name="email" id="email" type="text" value={field_email} onChange={(e) => setField_email(e.target.value)} required/>
                                </div>
                                <div className="small-12 medium-4 large-4 cell">
                                    <label htmlFor="fone" className="form-label">Fone</label>
                                    <input name="fone" id="fone" type="text" value={field_fone} onChange={(e) => setField_fone(e.target.value)} required/>
                                </div>
                            </div>
                            <hr/>
                            <div className="grid-x grid-padding-x">
                                    <div className="small-12 medium-4 large-4 cell">
                                    <label htmlFor="cep" className="form-label">Cep
                                    <input name="cep" id="cep" type="text" value={field_cep} onChange={(e) => setField_cep(e.target.value)} required/>
                                    </label>
                                </div>
                            </div>
                            <div className="grid-x grid-padding-x">
                                <div className="small-12 medium-8 large-8 cell">
                                    <label htmlFor="endereco" className="form-label">Endereço</label>
                                    <input name="endereco" id="endereco" type="text" value={field_endereco} onChange={(e) => setField_endereco(e.target.value)} className="form-control" placeholder="Endereço" required/>
                                </div>
                                <div className="small-12 medium-4 large-4 cell">
                                    <label htmlFor="numero" className="form-label">Numero</label>
                                    <input name="numero" id="numero" type="text" value={field_numero} onChange={(e) => setField_numero(e.target.value)} className="form-control" placeholder="Numero" required/>
                                </div>
                            </div>
                            <div className="grid-x grid-padding-x">
                                <div className="small-12 medium-6 large-6 cell">
                                    <label htmlFor="complemento" className="form-label">Complemento</label>
                                    <input name="complemento" id="complemento" value={field_complemento} onChange={(e) => setField_complemento(e.target.value)} type="text" className="form-control" placeholder="Complemento" required/>
                                </div>
                                <div className="small-12 medium-6 large-6 cell">
                                    <label htmlFor="bairro" className="form-label">Bairro</label>
                                    <input name="bairro" id="bairro" value={field_bairro} onChange={(e) => setField_bairro(e.target.value)} type="text" className="form-control" placeholder="Bairro" required/>
                                </div>
                                <div className="small-12 medium-8 large-8 cell">
                                    <label htmlFor="cidade" className="form-label">Cidade</label>
                                    <input name="cidade" id="cidade" value={field_cidade} onChange={(e) => setField_cidade(e.target.value)} type="text" className="form-control" placeholder="Cidade" required/>
                                </div>
                                <div className="small-12 medium-4 large-4 cell">
                                    <label htmlFor="proprietarioemail" className="form-label">E-mail do Proprietário</label>
                                    <select name="uf" id="uf" value={field_uf} onChange={(e) => setField_uf(e.target.value)} className="form-select" required>
                                        <option value="AC">Acre</option>
                                        <option value="AL">Alagoas</option>
                                        <option value="AP">Amapá</option>
                                        <option value="AM">Amazonas</option>
                                        <option value="BA">Bahia</option>
                                        <option value="CE">Ceará</option>
                                        <option value="DF">Distrito Federal</option>
                                        <option value="ES">Espírito Santo</option>
                                        <option value="GO">Goiás</option>
                                        <option value="MA">Maranhão</option>
                                        <option value="MT">Mato Grosso</option>
                                        <option value="MS">Mato Grosso do Sul</option>
                                        <option value="MG">Minas Gerais</option>
                                        <option value="PA">Pará</option>
                                        <option value="PB">Paraíba</option>
                                        <option value="PR">Paraná</option>
                                        <option value="PE">Pernambuco</option>
                                        <option value="PI">Piauí</option>
                                        <option value="RJ">Rio de Janeiro</option>
                                        <option value="RN">Rio Grande do Norte</option>
                                        <option value="RS">Rio Grande do Sul</option>
                                        <option value="RO">Rondônia</option>
                                        <option value="RR">Roraima</option>
                                        <option value="SC">Santa Catarina</option>
                                        <option value="SP">São Paulo</option>
                                        <option value="SE">Sergipe</option>
                                        <option value="TO">Tocantins</option>
                                        <option value="EX">Estrangeiro</option>
                                    </select>
                                </div>  
                            </div> 
                            <hr/>
                            <div className="grid-x grid-padding-x">
                                <div className="small-12 medium-6 large-6 cell">
                                    <label htmlFor="s1" className="form-label">Senha</label>
                                    <input name="s1" id="s1" value={field_s1} onChange={(e) => setField_s1(e.target.value)} type="password" className="form-control" placeholder=""/>
                                </div>
                                <div className="small-12 medium-6 large-6 cell">
                                    <label htmlFor="s2" className="form-label">Confirme sua Senha</label>
                                    <input name="s2" id="s2" value={field_s2} onChange={(e) => setField_s2(e.target.value)} type="password" className="form-control" placeholder=""/>
                                </div>
                            </div> 
                            <hr/>
                            <div className="grid-x grid-padding-x">
                                <div className="small-12 medium-12 large-12 cell">
                                <button type="submit" value="salvar" name="salvar" id="salvar" className="button float-right">Salvar</button>
                                </div>
                            </div> 

                    </form>



                </div>
            </div>

            </div>
        </div>
    );
  }
  
  export default Perfil;
  